var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-caption secondary--text",staticStyle:{"user-select":"none"}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-marker")]),_vm._v(" "+_vm._s(_vm.labelHint)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }